import general from "./general";
// import pveContent from './pve-content'
// import pvpContent from './pvp-content'
import classChanges from "./class-changes";
import factions from "./factions";
import professions from "./professions";
import itemization from "./itemization";
import raceChanges from "./race-changes";
import designGoals from "./design-goals";
// import phases from './phases'

export default {
  title: "Patch notes",
  sections: [
    designGoals,
    general,
    classChanges,
    raceChanges,
    // factions,
    // itemization,
    // professions,
  ],
};
